import { Injectable } from '@angular/core';
import { SingleDepartmentService } from '../../../shared/services/single-department.service';

@Injectable({
  providedIn: 'root',
})
export class FilterDepartmentService extends SingleDepartmentService {
  readonly NAME = 'Filter';

  defaultRoutes(roles: string[]): boolean {
    if (
      roles.some((role) =>
        [
          'Filters',
          'FilterOperator',
          'FilterChief',
          'FilterAdmin',
          'FilterViewer',
          'FilterOperator',
          'FilterLeader',
          'FiltersQualityControl',
        ].includes(role)
      )
    ) {
      this.router.navigate(['sb/filters-dep/scheduling/production']);
      return true;
    }
    return false;
  }
}
